import React, { useState } from 'react';
import {
  Box,
  Grid,
  Select,
  MenuItem,
  IconButton,
  Button,
  TextField,
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const DynamicFormHerp = () => {
  // const [rows, setRows] = useState([
  //   { id: 1, name: 'שורה 1', category: 'אורך רשומה', maxLength: 0, show: true, require:true },
  //   { id: 2, name: 'שורה 2', category: 'מפתח לקוח', maxLength: 15, show: true, require:true },
  //   { id: 3, name: 'שורה 3', category: 'אסמכתא', maxLength: 9, show: true, require:true },
  //   { id: 4, name: 'שורה 4', category: 'סוג מסמך', maxLength: 2, show: true, require:true },
  //   { id: 5, name: 'שורה 5', category: 'שם לקוח', maxLength: 50, show: true, require:true },
  //   { id: 6, name: 'שורה 6', category: 'כתובת', maxLength: 50, show: true, require:true },
  //   { id: 7, name: 'שורה 7', category: 'עיר', maxLength: 50, show: true, require:true },
  //   { id: 8, name: 'שורה 8', category: 'אסמכתא 2', maxLength: 9, show: true, require:true },
  //   { id: 9, name: 'שורה 9', category: 'תאריך אסמכתא', maxLength: 10, show: true, require:true },
  //   { id: 10, name: 'שורה 10', category: 'תאריך ערך', maxLength: 10, show: true, require:true },
  //   { id: 11, name: 'שורה 11', category: 'סוכן', maxLength: 9, show: true, require:true },
  //   { id: 12, name: 'שורה 12', category: 'מחסן', maxLength: 9, show: true, require:true },
  //   { id: 13, name: 'שורה 13', category: 'פרטים', maxLength: 250, show: true, require:true },
  //   { id: 14, name: 'שורה 14', category: 'מחסן מקור', maxLength: 9, show: true, require:true },
  //   { id: 15, name: 'שורה 15', category: 'סוכן לבנים', maxLength: 9, show: true, require:true },
  //   { id: 16, name: 'שורה 16', category: 'מחירון לבנים', maxLength: 1, show: true, require:true },
  //   { id: 17, name: 'שורה 17', category: 'הנחה כללית %', maxLength: 2.2, show: true, require:true },
  //   { id: 18, name: 'שורה 18', category: 'מע״מ %', maxLength: 2.2, show: true, require:true },
  //   { id: 19, name: 'שורה 19', category: 'מס׳ עותקים', maxLength: 2, show: true, require:true },
  //   { id: 20, name: 'שורה 20', category: 'מטבע מסמך', maxLength: 2, show: true, require:true },
  //   { id: 21, name: 'שורה 21', category: 'שער המסמך', maxLength: 5.4, show: true, require:true },

  //   { id: 22, name: 'שורה 22', category: 'מפתח פריט', maxLength: 15, show: true, require:true },
  //   { id: 23, name: 'שורה 23', category: 'כמות', maxLength: 15, show: true, require:true },
  //   { id: 24, name: 'שורה 24', category: 'מחיר', maxLength: 15, show: true, require:true },

  //   { id: 35, name: 'שורה 35', category: 'טלפון', maxLength: 15, show: true, require:true },

  //   { id: 62, name: 'שורה 62', category: 'דוא״ל איש קשר', maxLength: 15, show: true, require:true },
  // ]);


  const [rows, setRows] = useState([
    { id: 2, name: 'מפתח לקוח', category: 'אלפא נומרי', maxLength: 15, valueType: 'string', defaultValue: '31', show: true, require: true },
    { id: 3, name: 'מס\' מסמך', category: 'נומרי', maxLength: 9, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 4, name: 'סוג מסמך', category: 'נומרי', maxLength: 2, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 5, name: 'שם לקוח', category: 'אלפא נומרי', maxLength: 50, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 6, name: 'כתובת', category: 'אלפא נומרי', maxLength: 50, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 7, name: 'עיר', category: 'אלפא נומרי', maxLength: 50, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 8, name: 'אסמכתא 2', category: 'נומרי', maxLength: 9, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 9, name: 'תאריך אסמכתא', category: 'תאריך', maxLength: 10, valueType: 'date', defaultValue: '', show: true, require: true },
    { id: 10, name: 'תאריך ערך', category: 'תאריך', maxLength: 10, valueType: 'date', defaultValue: '', show: true, require: true },
    { id: 11, name: 'סוכן', category: 'נומרי', maxLength: 9, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 12, name: 'מחסן', category: 'נומרי', maxLength: 9, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 13, name: 'פרטים', category: 'אלפא נומרי', maxLength: 250, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 14, name: 'מחסן מקור', category: 'נומרי', maxLength: 9, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 15, name: 'סוכן לבנים', category: 'נומרי', maxLength: 9, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 16, name: 'מחירון לבנים', category: 'נומרי', maxLength: 1, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 17, name: '% הנחה כללית', category: 'עשרוני', maxLength: 2.2, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 18, name: '% מע"מ', category: 'עשרוני', maxLength: 2.2, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 19, name: 'מס\' עותקים', category: 'נומרי', maxLength: 2, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 20, name: 'מטבע המסמך', category: 'מטבע', maxLength: 4, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 21, name: 'שער המסמך', category: 'עשרוני', maxLength: 5.4, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 22, name: 'מפתח פריט', category: 'אלפא נומרי', maxLength: 20, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 23, name: 'כמות', category: 'עשרוני', maxLength: 6.3, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 24, name: 'מחיר', category: 'עשרוני', maxLength: 6.3, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 35, name: 'טלפון', category: 'אלפאנומרי', maxLength: 30, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 62, name: 'דוא"ל איש קשר', category: 'אלפאנומרי', maxLength: 50, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 63, name: 'refnum', category: 'אלפאנומרי', maxLength: 50, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 64, name: 'קובץ כותרת', category: 'אלפאנומרי', maxLength: 100, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 65, name: 'קובץ תנועה', category: 'אלפאנומרי', maxLength: 100, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 66, name: 'איש קשר', category: 'אלפאנומרי', maxLength: 50, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 67, name: 'קוד תמחיר תנועה', category: 'אלפאנומרי', maxLength: 8, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 68, name: 'שם פריט חלופי', category: 'אלפאנומרי', maxLength: 100, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 69, name: 'כרטיס הכנסות / הוצאות', category: 'אלפאנומרי', maxLength: 15, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 70, name: 'תאריך ערך בתנועה', category: 'תאריך', maxLength: 10, valueType: 'date', defaultValue: '', show: true, require: true },
    { id: 71, name: 'פרטים בתנועה', category: 'אלפאנומרי', maxLength: 20, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 72, name: 'מחסן בתנועה', category: 'נומרי', maxLength: 9, valueType: 'number', defaultValue: '', show: true, require: true },
    { id: 73, name: 'מטבע שערוך', category: 'אלפאנומרי', maxLength: 5, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 74, name: 'כתובת לייצוא', category: 'אלפאנומרי', maxLength: 250, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 75, name: 'הערות לייצוא', category: 'אלפאנומרי', maxLength: 250, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 76, name: 'סוג תנועה', category: 'אלפאנומרי', maxLength: 3, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 77, name: 'סוג תנועה פטור', category: 'אלפאנומרי', maxLength: 3, valueType: 'string', defaultValue: '', show: true, require: true },
    { id: 78, name: 'שער לשערוך', category: 'עשרוני', maxLength: 5, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 79, name: 'תאריך נוסף 1 כותרת', category: 'תאריך', maxLength: 10, valueType: 'date', defaultValue: '', show: true, require: true },
    { id: 80, name: 'תאריך נוסף 2 כותרת', category: 'תאריך', maxLength: 10, valueType: 'date', defaultValue: '', show: true, require: true },
    { id: 81, name: 'מספר נוסף 1 כותרת', category: 'עשרוני', maxLength: 13, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 82, name: 'מספר נוסף 2 כותרת', category: 'עשרוני', maxLength: 13, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 83, name: 'תאריך נוסף 1 תנועה', category: 'תאריך', maxLength: 10, valueType: 'date', defaultValue: '', show: true, require: true },
    { id: 84, name: 'תאריך נוסף 2 תנועה', category: 'תאריך', maxLength: 10, valueType: 'date', defaultValue: '', show: true, require: true },
    { id: 85, name: 'מספר נוסף 1 תנועה', category: 'עשרוני', maxLength: 13, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 86, name: 'מספר נוסף 2 תנועה', category: 'עשרוני', maxLength: 13, valueType: 'decimal', defaultValue: '', show: true, require: true },
    { id: 87, name: 'מספר הקצאה', category: 'אלפאנומרי', maxLength: 250, valueType: 'string', defaultValue: '', show: true, require: true },
  ]);

  const [formRows, setFormRows] = useState([
    { country: '', inputValue: '' },
  ]);

  const handleChange = (index, field, value) => {
    const updatedRows = [...formRows];
    updatedRows[index][field] = value;
    if (field === 'country') {
      updatedRows[index].inputValue = '';
    }
    setFormRows(updatedRows);
  };

  const handleAddRow = () => {
    setFormRows([...formRows, { country: '', inputValue: '' }]);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = formRows.filter((_, i) => i !== index);
    setFormRows(updatedRows);
  };

  const handleSubmit = () => {
    console.log('Submitted Data:', formRows);
  };

  return (
    <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '8px' }}>
      {formRows.map((row, index) => (
        <Box key={index} mb={2}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={4}>
              <Select
                fullWidth
                value={row.country}
                onChange={(e) => handleChange(index, 'country', e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  בחר שורה
                </MenuItem>
                {rows.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={7}>
              <TextField
                fullWidth
                value={row.inputValue}
                onChange={(e) => handleChange(index, 'inputValue', e.target.value)}
                inputProps={{
                  maxLength: rows.find((r) => r.id === row.country)?.maxLength || 0,
                }}
                disabled={!row.country}
                placeholder="הזן תוכן"
              />
            </Grid>
            <Grid item xs={1}>
              {index > 0 && (
                <IconButton color="error" onClick={() => handleRemoveRow(index)}>
                  <RemoveCircleOutlineIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
        </Box>
      ))}
      <Box mt={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddCircleOutlineIcon />}
          onClick={handleAddRow}
        >
          הוסף רובריקה
        </Button>
      </Box>
      <Box mt={2}>
        <Button variant="contained" color="success" onClick={handleSubmit}>
          שליחה
        </Button>
      </Box>
    </Box>
  );
};

export default DynamicFormHerp;
